<ion-chip class="status-tag">
  <ion-label data-testid="tag" [innerHTML]="tag"></ion-label>
  <ion-icon data-testid="icon" name="ellipse" [color]="color"></ion-icon>
</ion-chip>
